import React, { useCallback, useEffect, useRef, useState } from "react";
import PropTypes, { element } from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FilterListIcon from "@mui/icons-material/FilterList";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import { visuallyHidden } from "@mui/utils";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import TextField from "@mui/material/TextField";
import {
  SearchIcon,
  FilterAltOutlinedIcon,
  DownloadIcon,
  CloudOffIcon,
} from "../../../Resources/Icons/icons";
import Autocomplete from "@mui/material/Autocomplete";
import {
  GetBranch,
  GetCompany,
  GetSubProduct,
  GetPolicyType,
  GetSubBookingCode,
  GetMasterReport,
  GetUser,
  GetMasterReportExcelFormat,
  GetPolicyFileById,
  ReframeEndDateTimeFormat,
} from "../../../Service/_index";
import { Select, Space } from "antd";
import { DatePicker } from "antd";
import {
  checkUserType,
  filterOption,
  filterSort,
} from "../../../Shared/CommonConstant";
import moment from "moment";
import dayjs from "dayjs";
import Drawer from "@mui/material/Drawer";
import DownloadReport from "./DownloadReport";
import PolicyFileDownloadDialog from "../../../UiComponents/PolicyFileDownload/PolicyFileDownloadDialog";
import { CSVLink } from "react-csv";
import Loader from "../../../UiComponents/Loader/Loader";
import { ToastError } from "../../../UiComponents/Toaster/Toast";
import { saveAs } from "file-saver";
import * as ExcelJS from "exceljs";
import { debounce } from "../../../Shared/debounce";
import { formatLoginIdForReport } from "../../../Shared/loginId";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import TabFilter from "../../Tabs/Tabs";
import { Divider, Modal, Stack, Badge, CircularProgress } from "@mui/material";
import filterr from "../../../Resources/Images/filter-lines.png";
import exportt from "../../../Resources/Images/export.png";
import FilterBox from "../../../UiComponents/FilterBox/FilterBox";
import CustomButton from "../../../UiComponents/CommonBUtton/ConfirmBox";
import file from "../../../Resources/Images/file.png";
import car from "../../../Resources/Images/car.png";
import tpCar from "../../../Resources/Images/tpCar.png";
import net from "../../../Resources/Images/net.png";
import total from "../../../Resources/Images/total.png";
import CustomModal from "../../../UiComponents/CustomModel/CustomModel";
import CustomCheckboxList from "../../../UiComponents/CommonCheckBox/CommonCheckBox";
import ViewColumnOutlinedIcon from "@mui/icons-material/ViewColumnOutlined";

const { RangePicker } = DatePicker;
const { Option } = Select;
const TodayDate = new Date();

const Last7Days = new Date();
Last7Days.setDate(Last7Days.getDate() - 7);
const YesterDay = new Date();
YesterDay.setDate(YesterDay.getDate() - 1);
const Last30Days = new Date();
Last30Days.setDate(Last30Days.getDate() - 30);

const TodayDateByDaysjs = dayjs();
const FirstDateOfMonth = TodayDateByDaysjs.startOf("month");
const FirstDateOfLastMonth = TodayDateByDaysjs.subtract(1, "month").startOf(
  "month",
);
const LastDateOfLastMonth = TodayDateByDaysjs.subtract(1, "month").endOf(
  "month",
);
const UserType = sessionStorage.getItem("userType");

const formatNumber = (num) => new Intl.NumberFormat("en-IN").format(num);

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const tempHeadCells = [
  {
    id: "issueDate",
    placeMent: true,
    disablePadding: false,
    label: "Policy Date",
  },
  {
    id: "company",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "policyNumber",
    placeMent: true,
    disablePadding: false,
    label: "Policy Number",
  },
  {
    id: "customerName",
    placeMent: true,
    disablePadding: false,
    label: "Customer Name",
  },
  {
    id: "registrationNumber",
    placeMent: true,
    disablePadding: false,
    label: "Reg Number",
  },
  {
    id: "odPremium",
    placeMent: true,
    disablePadding: false,
    label: "OD Premium",
  },
  {
    id: "tpPremium",
    placeMent: true,
    disablePadding: false,
    label: "TP Premium",
  },
  {
    id: "netPremium",
    placeMent: true,
    disablePadding: false,
    label: "NET Premium",
  },
  {
    id: "totalPremium",
    placeMent: true,
    disablePadding: false,
    label: "Totl Premium",
  },
  {
    id: "userEmail",
    placeMent: true,
    disablePadding: false,
    label: "User Email",
  },
];

const getClassName = (data) => {
  return data.policyNumber ? "file_link" : null;
};

const intialHeadCells = [
  {
    id: "formateIssueDate",
    placeMent: true,
    disablePadding: false,
    label: "Policy Date",
  },
  {
    id: "company",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "policyNumber",
    placeMent: true,
    disablePadding: false,
    label: "Policy Number",
    class: getClassName,
    onClick: true,
  },
  {
    id: "customerName",
    placeMent: true,
    disablePadding: false,
    label: "Customer Name",
  },
  {
    id: "registrationNumber",
    placeMent: true,
    disablePadding: false,
    label: "Register Number",
  },
  {
    id: "odPremium",
    placeMent: true,
    disablePadding: false,
    label: "OD Premium",
  },
  {
    id: "tpPremium",
    placeMent: true,
    disablePadding: false,
    label: "TP Premium",
  },
  {
    id: "netPremium",
    placeMent: true,
    disablePadding: false,
    label: "NET Premium",
  },
  {
    id: "totalPremium",
    placeMent: true,
    disablePadding: false,
    label: "Total Premium",
  },
  {
    id: "userEmail",
    placeMent: true,
    disablePadding: false,
    label: "User E-mail ID",
  },
];

const MasterReport = () => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [report, setReport] = React.useState([]);
  const [summaryData, setSummary] = React.useState({});
  const [openDrawer, setOpenDrawer] = useState(false);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [userDetails, setUserDetails] = useState([]); // Changes by Arun
  const [bookingCodeDetails, setBookingCodeDetails] = useState([]);
  const [branchDetails, setBranchDetails] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const [policyTypeDetails, setPolicyTypeDetails] = useState([]);
  const [vehicleMakeDetails, setVehicleMakeDetails] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState();
  const [selectedUser, setSelectedUser] = useState(); //Changes by Arun
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [selectedBookingCode, setSelectedBookingCode] = useState();
  const [selectedSubBookingCode, setSelectedSubBookingCode] = useState([]);
  const [selectedItems, setSelectedItems] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [filtersVisible, setFiltersVisible] = useState(false);
  const [button, setButton] = useState("master"); // default to master
  const [selectedSubProduct, setSelectedSubProduct] = useState([]);
  const [selectedPolicyType, setSelectedPolicyType] = useState([]);
  // const [selectedVehicleMake,setSelectedVehicleMake]=useState([]);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [openLoader, setOpenLoader] = useState(false);
  const [apiReqBody, setApiReqBody] = useState({}); // Added by Arun
  const [tableConfig, setTableConfig] = useState({
    isSearch: true,
    isApprove: true,
    // isMultiDelete: true,
    type: "masterReport",
  });
  const [company, setCompany] = React.useState([]);
  const [openCompanyDrawer, setOpenCompanyDrawer] = React.useState(false);
  const [formType, setFormType] = useState("");
  const [selectedData, setSelectedData] = React.useState({});
  const [openConfirmBox, setOpenConfirmBox] = React.useState(false);
  const [activeBoolean, setActiveBoolean] = useState();
  const [openDeleteConfirmBox, setOpenDeleteConfirmBox] = React.useState(false);
  const [isFirstRender, setIsFirstRender] = useState(true);
  const [selectedTab, setSelectedTab] = useState(1);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [headCells, setHeadCells] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const latestDateRangeRef = useRef([]);
  const [searchText, setSearchText] = useState("");
  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });

  const [count, setCount] = useState(0);
  const [showColumns, setShowColumns] = useState(false);
  const [openPolicyFileDownload, setOpenPolicyFileDownload] = useState(false);
  const [UserType, setUserType] = useState(null);
  // Read synchronously: the UserType / isAllow state is only filled by an effect (null / {} on first paint)
  const isUserRole = checkUserType(sessionStorage.getItem("userType")).isUser;
  const buttonRef = useRef(null);
  const [queryParam, setQueryParam] = useState({
    page: 1,
    limit: 10,
    search: "",
    sort: "",
  });
  const [isAllow, setIsAllow] = useState({});

  // Filter columns based on user type
  const filteredInitialHeadCells = React.useMemo(() => {
    return intialHeadCells.filter((cell) => {
      if (cell.id === "userEmail") {
        return UserType !== "SUBCODE" && UserType !== "user";
      }
      return true;
    });
  }, [UserType]);

  const filteredTempHeadCells = React.useMemo(() => {
    return tempHeadCells.filter((cell) => {
      if (cell.id === "userEmail" || cell.label === "User Email") {
        return UserType !== "SUBCODE" && UserType !== "user";
      }
      return true;
    });
  }, [UserType]);

  // Update headCells and selectedColumns when filtered columns change
  React.useEffect(() => {
    if (filteredInitialHeadCells.length > 0) {
      setHeadCells(filteredInitialHeadCells);
      setSelectedColumns(filteredInitialHeadCells);
    }
  }, [filteredInitialHeadCells]);

  const FilterOption = [
    {
      label: "Master",
      isEnabled: "all",
      value: 1,
    },
    {
      label: "Score",
      isEnabled: "true",
      value: 2,
    },
  ];

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    if (newValue == 1) {
      getTableData.bind(null, "MASTER");
    } else if (newValue == 2) {
      getTableData.bind(null, "SCORE");
    }
  };

  function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
      setQueryParam({
        ...queryParam,
        sort: order === "desc" ? `-${property}` : property,
      });
      onRequestSort(event, property);
    };
    // Added by Arun
    const headCells = filteredTempHeadCells;

    return (
      <TableHead>
        <TableRow>
          {headCells?.map((headCell) => (
            <TableCell
              className="TableHeader"
              key={headCell.id}
              align={headCell.placeMent ? "left" : "center"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={{ fontSize: "16px", fontWeight: 600 }}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell?.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setQueryParam({ ...queryParam, page: newPage + 1, limit: rowsPerPage });
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 20));
    setPage(0);
  };

  const debouncedHandleSearch = useCallback(
    debounce((searchText) => {
      setQueryParam((queryParams) => ({
        ...queryParams,

        search: searchText,
      }));
    }, 300),

    [],
  );

  const handleSearch = (searchText) => {
    debouncedHandleSearch(searchText);
  };

  const FilteredData = company.filter((el) => {
    return `${el?.companyName},${el?.remarks},${el?.shortName}`.includes();
  });

  console.log("report", report);

  const GetData = () => {
    GetCompany({ isAscending: false }).then((res) => {
      const updatedData = res?.data.map((item) => ({
        ...item,
        status: item.isEnabled ? "Active" : "Inactive",
      }));
      setCompany(updatedData);
    });
  };

  const EditCompanyData = (row) => {
    setSelectedData(row);
    setOpenCompanyDrawer(true);
    setFormType("edit");
  };

  const ViewCompanyData = (row) => {
    setSelectedData(row);
    setOpenCompanyDrawer(true);
    setFormType("view");
  };

  const ActiveCompanyData = (row, active) => {
    setOpenConfirmBox(true);
    setSelectedData(row);
    setActiveBoolean(!active);
  };

  const DeleteCompanyData = (row) => {
    setOpenDeleteConfirmBox(true);
    setSelectedData(row);
  };

  const GetUserDetails = () => {
    const bodyData = {
      requesttype: "TABLE",
      isAscending: true,
    };
    // Branch manager must only see the users that belong to their own branch.
    // The backend already restricts /user by branchManager, but we also guard on
    // the frontend so the User filter can never list users of another branch.
    const currentUserType = sessionStorage.getItem("userType");
    const loginUserId = sessionStorage.getItem("UserId");
    const { isBranchManager } = checkUserType(currentUserType);
    GetUser(bodyData).then((res) => {
      const FilteredData =
        res?.data
          ?.filter((e) => {
            if (!isBranchManager) return true;
            const branchManagerId =
              e?.branchManager?._id || e?.branchManager || "";
            return branchManagerId?.toString() === loginUserId;
          })
          ?.map((e) => {
            if (e.isEnabled && e?.userType.includes("user")) {
              return {
                ...e,
                label: e.name + " - " + e.mobileNumber + " - " + e.email,
                value: e?._id,
              };
            } else {
              return null;
            }
          }) || [];
      setUserDetails(FilteredData.filter(Boolean));
    });
  };

  const GetCompanyDetails = () => {
    GetCompany({ isAscending: true }).then((res) => {
      const FilteredData =
        res?.data?.map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e?.shortName,
              value: e?._id,
            };
          } else {
            return null;
          }
        }) || [];
      setCompanyDetails(FilteredData.filter(Boolean));
    });
  };

  const GetBookingCodeDetails = () => {
    GetSubBookingCode({ isAscending: "combineData" }).then((res) => {
      let FilteredData = [];
      res?.data?.map((e) => {
        if (e.isEnabled) {
          FilteredData.push({
            ...e,
            label: e?.bookingCode + " - " + e?.subBookingCode,
            value: e?._id,
          });
        }
        // else {
        //   return null;
        // }
      });
      console.log("FilteredData ", FilteredData);
      setBookingCodeDetails(FilteredData);
    });
  };

  const GetBranchDetails = async () => {
    try {
      const [branchRes, userRes] = await Promise.all([
        GetBranch(),
        GetUser({ requesttype: "TABLE", isAscending: true }),
      ]);
      const branches = branchRes?.data || [];
      const users = userRes?.data || [];

      const FilteredData = [];

      branches.forEach((branch) => {
        if (branch.isEnabled) {
          // Find ALL managers assigned to this branch
          const managers = users.filter(
            (u) =>
              u.branchId &&
              u.branchId._id === branch._id &&
              u.userType &&
              Array.isArray(u.userType) &&
              u.userType.some((type) =>
                type.toLowerCase().includes("branchmanager"),
              ),
          );

          if (managers.length > 0) {
            // If the branch has managers, create an entry for each one
            managers.forEach((manager) => {
              FilteredData.push({
                _id: `manager_${manager._id}`, // UNIQUE ID FOR FILTERBOX
                label: `${manager.name} - ${branch.branchName}`,
                value: `manager_${manager._id}`,
                branchId: branch._id,
                branchName: branch.branchName,
                isManagerOption: true,
              });
            });
          } else {
            // No managers found, just list the branch itself
            FilteredData.push({
              _id: `branch_${branch._id}`, // UNIQUE ID FOR FILTERBOX
              label: branch.branchName,
              value: `branch_${branch._id}`,
              branchId: branch._id,
              branchName: branch.branchName,
              isManagerOption: false,
            });
          }
        }
      });

      setBranchDetails(FilteredData);
    } catch (error) {
      console.error("Error fetching branch details:", error);
    }
  };

  const GetProductDetails = () => {
    GetSubProduct({ isAscending: "combineData" }).then((res) => {
      const modifiedProductDetails = (res?.data || [])
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e?.product + " - " + e?.subProduct,
              value: e?._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setProductDetails(modifiedProductDetails);
    });
  };

  const GetPolicyTypeDetails = () => {
    GetPolicyType({ isAscending: true }).then((res) => {
      const FilteredData = (res?.data || []).map((e) => {
        if (e.isEnabled) {
          return {
            ...e,
            label: e?.policyType,
            value: e?._id,
          };
        } else {
          return null;
        }
      });
      setPolicyTypeDetails(FilteredData);
    });
  };

  React.useEffect(() => {
    GetUserDetails();
    GetCompanyDetails();
    GetBookingCodeDetails();
    GetBranchDetails();
    GetProductDetails();
    GetPolicyTypeDetails();
  }, []);

  const HandleCustomDays = (startDate, endDate) => {
    const start = dayjs(startDate).startOf("day");
    const end = dayjs(endDate).endOf("day");
    setSelectedStartDate(start);
    setSelectedEndDate(end);
    const range = [start, end];
    latestDateRangeRef.current = range;
    setDateRange(range);
    setIsDatePickerOpen(false);
  };

  const headers = [
    { header: "Approve Date", key: "approveDate", id: "Policy Details" }, // Changes by Arun
    { header: "Issue Date", key: "formateIssueDate", id: "Policy Details" },
    { header: "User Name", key: "userName", id: "Policy Details" }, // Changes by Arun
    { header: "Status", key: "status", id: "Policy Details" },
    {
      header: "Cancel Policy Remarks",
      key: "cancelPolicyRemarks",
      id: "Policy Details",
    },
    {
      header: "Branch Manager",
      key: "branchManagerName",
      id: "Policy Details",
    },
    { header: "Booking Code", key: "bookingCode", id: "Policy Details" }, // Changes by Arun
    { header: "Sub Booking Code", key: "subBookingCode", id: "Policy Details" }, // Changes by Arun
    { header: "Company Name", key: "company", id: "Policy Details" },
    { header: "Product", key: "product", id: "Policy Details" }, // Changes by Arun
    { header: "Sub Product", key: "subProduct", id: "Policy Details" }, // Changes by Arun
    { header: "Policy Type", key: "policyType", id: "Policy Details" }, // Changes by Arun
    { header: "Policy Number", key: "policyNumber", id: "Policy Details" },
    { header: "Login Id", key: "loginID", id: "Policy Details" }, // Changes by Arun
    // { label: "Customer Name", key: "customerName" },
    // { label: "Payment Mode", key: "paymentMode" }, // Changes by Arun
    // { label: "OD Premium", key: "odPremium" },
    // { label: "TP Premium", key: "tpPremium" },
    // { label: "Net Premium", key: "netPremium" },
    // { label: "Total Premium", key: "totalPremium" },
    // { label: "User Email", key: "userEmail" },
    // { label: "Vehicle Make", key: "vehicleMake" }, //added by gokul..
  ];

  // Changed by Arun
  const userHeaders = [
    { header: "Approve Date", key: "approveDate", id: "Policy Details" }, // Changes by Arun
    { header: "Issue Date", key: "formateIssueDate", id: "Policy Details" },
    { header: "User Name", key: "userName", id: "Policy Details" }, // Changes by Arun
    // { header: "Status", key: "branchManagerName", id: "Policy Details" },
    { header: "Booking Code", key: "bookingCode", id: "Policy Details" }, // Changes by Arun
    { header: "Sub Booking Code", key: "subBookingCode", id: "Policy Details" }, // Changes by Arun
    { header: "Company Name", key: "company", id: "Policy Details" },
    { header: "Product", key: "product", id: "Policy Details" }, // Changes by Arun
    { header: "Sub Product", key: "subProduct", id: "Policy Details" }, // Changes by Arun
    { header: "Policy Type", key: "policyType", id: "Policy Details" }, // Changes by Arun
    { header: "Policy Number", key: "policyNumber", id: "Policy Details" },
    { header: "Login Id", key: "loginID", id: "Policy Details" },
    {
      header: "Customer Name",
      key: "customerName",
      id: "Customer Details", //Changes by Arun
    },
    {
      header: "Mobile",
      key: "mobileNumber",
      id: "Customer Details", //Changes by Arun
    },
    {
      header: "Email",
      key: "email",
      id: "Customer Details", //Changes by Arun
    },
    {
      header: "RTO",
      key: "rtoId",
      id: "Vehicle Details", //Changes by sankarNagarajan
    },
    {
      header: "Reg Number",
      key: "registrationNumber",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "Vechicle Make",
      key: "vehicleMake",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "Model",
      key: "model",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "Engine No",
      key: "engineNumber",
      id: "Vehicle Details",
    },
    {
      header: "Chassis No",
      key: "chassisNumber",
      id: "Vehicle Details",
    },
    {
      header: "Reg Year",
      key: "registrationYear",
      id: "Vehicle Details", //Changes by Arun
    },

    {
      header: "GVW",
      key: "gvw",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "CC",
      key: "cc",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "Seat Capacity",
      key: "seatingCapacity",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "Fuel Type",
      key: "fuelType",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      // A policy can carry many add ons - the backend joins their names with a comma
      header: "Add On",
      key: "addOn",
      id: "Vehicle Details",
    },
    {
      header: "PA Cover",
      key: "paCover",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "OD Discount",
      key: "odDisc",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "OD Premium",
      key: "odPremium",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "TP Premium",
      key: "tpPremium",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "Net Premium",
      key: "netPremium",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "Total Premium",
      key: "totalPremium",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "OD Start Date",
      key: "formateOdPolicyStartDate",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "OD Period",
      key: "odPolicyPeriod",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "OD End Date",
      key: "formateOdPolicyEndDate",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "TP Start Date",
      key: "formateTpPolicyStartDate",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "TP Period",
      key: "tpPolicyPeriod",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "TP End Date",
      key: "formateTpPolicyEndDate",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "OD %",
      key: "payODPer",
      id: "User Payable", //Changes by Arun
    },
    {
      header: "OD Amt",
      key: "payODAmount",
      id: "User Payable", //Changes by Arun
    },
    {
      header: "TP %",
      key: "payTPPer",
      id: "User Payable", //Changes by Arun
    },
    {
      header: "TP Amt",
      key: "payTPAmount",
      id: "User Payable", //Changes by Arun
    },
    {
      header: "Net %",
      key: "payNetPer",
      id: "User Payable", //Changes by Arun
    },
    {
      header: "Net Amt",
      key: "payNetAmount",
      id: "User Payable", //Changes by Arun
    },
    {
      header: "Total Amount",
      key: "totalPayableAmount",
      id: "User Payable", //Changes by Arun
    },
    {
      header: "Additional Percentage",
      key: "additionalPercentage",
      id: "User Payable", //Changes by Arun
    },
    {
      header: "Additional Amount",
      key: "additionalAmount",
      id: "User Payable", //Changes by Arun
    },
    {
      header: "Total Amount",
      key: "totalamount",
      id: "User Payable", //Changes by Arun
    },
    {
      header: "Total Amount",
      key: "payOdTpNetTotal",
      id: "User Payable",
    },
  ];

  // Changed by Arun
  const subBookingCodeUserHeaders = [
    { header: "Approve Date", key: "approveDate", id: "Policy Details" }, // Changes by Arun
    { header: "Issue Date", key: "formateIssueDate", id: "Policy Details" },
    // { header: "User Name", key: "userName", id: "Policy Details" }, // Changes by Arun
    // { header: "Branch Manager", key: "branchManagerName", id: "Policy Details" },
    { header: "Booking Code", key: "bookingCode", id: "Policy Details" }, // Changes by Arun
    { header: "Sub Booking Code", key: "subBookingCode", id: "Policy Details" }, // Changes by Arun
    { header: "Company Name", key: "company", id: "Policy Details" },
    { header: "Product", key: "product", id: "Policy Details" }, // Changes by Arun
    { header: "Sub Product", key: "subProduct", id: "Policy Details" }, // Changes by Arun
    { header: "Policy Type", key: "policyType", id: "Policy Details" }, // Changes by Arun
    { header: "Policy Number", key: "policyNumber", id: "Policy Details" },
    { header: "Login Id", key: "loginID", id: "Policy Details" },
    {
      header: "Customer Name",
      key: "customerName",
      id: "Customer Details", //Changes by Arun
    },
    {
      header: "RTO",
      key: "rtoId",
      id: "Vehicle Details", //Changes by sankarNagarajan
    },
    {
      header: "Reg Number",
      key: "registrationNumber",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "Vechicle Make",
      key: "vehicleMake",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "Model",
      key: "model",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "Engine No",
      key: "engineNumber",
      id: "Vehicle Details",
    },
    {
      header: "Chassis No",
      key: "chassisNumber",
      id: "Vehicle Details",
    },
    {
      header: "Reg Year",
      key: "registrationYear",
      id: "Vehicle Details", //Changes by Arun
    },

    {
      header: "GVW",
      key: "gvw",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "CC",
      key: "cc",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "Seat Capacity",
      key: "seatingCapacity",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "Fuel Type",
      key: "fuelType",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      // A policy can carry many add ons - the backend joins their names with a comma
      header: "Add On",
      key: "addOn",
      id: "Vehicle Details",
    },
    {
      header: "PA Cover",
      key: "paCover",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "OD Discount",
      key: "odDisc",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "OD Premium",
      key: "odPremium",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "TP Premium",
      key: "tpPremium",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "Net Premium",
      key: "netPremium",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "Total Premium",
      key: "totalPremium",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "OD Start Date",
      key: "formateOdPolicyStartDate",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "OD Period",
      key: "odPolicyPeriod",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "OD End Date",
      key: "formateOdPolicyEndDate",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "TP Start Date",
      key: "formateTpPolicyStartDate",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "TP Period",
      key: "tpPolicyPeriod",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "TP End Date",
      key: "formateTpPolicyEndDate",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "OD %",
      key: "recODPer",
      id: "Receivable", //Changes by Arun
    },
    {
      header: "OD Amt",
      key: "recODAmount",
      id: "Receivable", //Changes by Arun
    },
    {
      header: "TP %",
      key: "recTPPer",
      id: "Receivable", //Changes by Arun
    },
    {
      header: "TP Amt",
      key: "recTPAmount",
      id: "Receivable", //Changes by Arun
    },
    {
      header: "Net %",
      key: "recNetPer",
      id: "Receivable", //Changes by Arun
    },
    {
      header: "Net Amt",
      key: "recNetAmount",
      id: "Receivable", //Changes by Arun
    },
    {
      header: "Total Amount",
      key: "recOdTpNetTotal",
      id: "Receivable",
    },
  ];

  const csvFile = {
    filename: "Master Report Data",
    headers: headers,
    data: report,
  };

  // Changes by Arun
  const userDownloadExcel = async () => {
    let selectedBranchId = "";
    let selectedBranchmanager = "";

    if (selectedBranch) {
      if (selectedBranch.startsWith("manager_")) {
        selectedBranchmanager = selectedBranch.replace("manager_", "");
      } else if (selectedBranch.startsWith("branch_")) {
        selectedBranchId = selectedBranch.replace("branch_", "");
      }
    }

    apiReqBody.selectedBranchId = selectedBranchId;
    apiReqBody.selectedBranchmanager = selectedBranchmanager;
    apiReqBody.isDownloadExcel = true;
    // console.log("apiReqBody ", apiReqBody);
    let selectedColumns =
      UserType == "SUBCODE" ? subBookingCodeUserHeaders : userHeaders;
    const selectedHeader = [
      ...new Set(selectedColumns.map((element) => element?.id)),
    ];
    apiReqBody.selectedHeader = selectedHeader;
    // return true;
    setOpenLoader(true);
    await GetMasterReport("MASTER", apiReqBody)
      .then((res) => {
        const FormatedData = res?.data?.tableData ? res.data.tableData : [];
        FormatedData.map((element) => {
          element.loginID = formatLoginIdForReport(
            element.loginId,
            element.userName,
          );
          // Note: formateCreatedAt, formateVerifyPendingAt, formateApprovePendingAt
          // are already formatted in IST by the backend. Do not overwrite here.
        });

        let wb = new ExcelJS.Workbook();
        let workbookName = "Master Report All Data.xlsx";
        let worksheetName = "Master Report";
        let ws = wb.addWorksheet(worksheetName, {
          properties: {
            tabColor: { argb: "FFFF0000" },
          },
        });

        ws.columns =
          UserType == "SUBCODE" ? subBookingCodeUserHeaders : userHeaders;
        console.log("ws.columns  ", ws.columns);
        ws.addRows(FormatedData);

        ws.eachRow((row, rowNumber) => {
          row.eachCell({ includeEmpty: true }, (cell) => {
            // Set default border style for all cells (including empty cells)
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          });
        });

        wb.xlsx.writeBuffer().then(function (buffer) {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            workbookName,
          );
        });
      })
      .finally(() => {
        setOpenLoader(false);
      });
  };
  const getTableData = async (requestType, options = {}) => {
    // console.log(selectedStartDate);
    // console.log(selectedEndDate);
    try {
      const overrideStartDate = options.overrideStartDate;
      const overrideEndDate = options.overrideEndDate;

      const startDateToUse = overrideStartDate || selectedStartDate;
      const endDateToUse = overrideEndDate || selectedEndDate;

      if (!startDateToUse || !endDateToUse) {
        ToastError("Please select date range");
        return true;
      }
      // Changes by Arun
      setOpenLoader(true);
      let endDate = null;
      if (endDateToUse) {
        endDate = await ReframeEndDateTimeFormat(endDateToUse);
      }
      let selectedBranchId = "";
      let selectedBranchmanager = "";

      if (selectedBranch) {
        if (selectedBranch.startsWith("manager_")) {
          selectedBranchmanager = selectedBranch.replace("manager_", "");
        } else if (selectedBranch.startsWith("branch_")) {
          selectedBranchId = selectedBranch.replace("branch_", "");
        }
      }

      const reqBody = {
        ...apiReqBody,
        selectedProductIdList: selectedProduct,
        selectedSubProductIdList: selectedSubProduct,
        selectedBookingCodeId: selectedBookingCode,
        selectedSubBookingCodeId: selectedSubBookingCode,
        selectedUserId: selectedUser,
        selectedCompanyIdList: selectedCompany,
        selectedBranchId: selectedBranchId,
        selectedBranchmanager: selectedBranchmanager,
        selectedPolicyTypeIdList: selectedPolicyType,
        selectedStartDate: startDateToUse,
        selectedEndDate: endDate,
        // the Score summary is not cancel-aware: Cancel Date is only for the Master list
        selectedFilterType:
          requestType === "SCORE" && selectedFilterType === "cancelDate"
            ? "issueDate"
            : selectedFilterType,
        page: queryParam.page,
        limit: queryParam.limit,
        search: queryParam.search,
        sort: queryParam.sort,
        isDownloadExcel: false,
      };
      setApiReqBody(reqBody);
      await GetMasterReport(requestType, reqBody)
        .then((res) => {
          const FormatedData = res?.data?.tableData ? res.data.tableData : [];
          FormatedData.map((element) => {
            element.loginID = formatLoginIdForReport(
              element.loginId,
              element.userName,
            );
            element.formateIssueDate = moment(element?.issueDate).format(
              "DD-MM-YYYY",
            );
          });
          setExcelData(FormatedData);
          console.log("FormatedData", FormatedData);
          setReport(FormatedData);
          setCount(res?.data?.policyCount);
          let data = res?.data;
          if (data) {
            delete data["tableData"];
            setSummary(data);
          } else {
            setSummary({});
            setPage(0);
          }
        })
        .finally(() => {
          // Changes by Arun
          setOpenLoader(false);
        });
    } catch (err) {
      console.log("err", err);
    }
  };

  // Changes by Arun comment this function
  // const GetMasterReportExcelData = () => {
  //   let data = {
  //     selectedProductIdList: selectedProduct,
  //     selectedSubProductIdList: selectedSubProduct,
  //     selectedBookingCodeId: selectedBookingCode,
  //     selectedSubBookingCodeId: selectedSubBookingCode,
  //     selectedUserId: selectedUser,
  //     selectedCompanyIdList: selectedCompany,
  //     selectedBranchId: selectedBranch,
  //     selectedPolicyTypeIdList: selectedPolicyType,
  //     selectedStartDate: selectedStartDate,
  //     selectedEndDate: selectedEndDate,
  //     // selectedVehicleMakeIdList:selectedVehicleMake,//added by gokul..
  //   };

  //   GetMasterReportExcelFormat(data).then((res) => {
  //     console.log(res?.data)
  //     // setExcelData(res);
  //     const modifiedData=res?.data?.map((e)=>{
  //       return {
  //         ...e,
  //         formateIssueDate: moment(e.issueDate).format("DD/MM/YYYY"),
  //         formateOdPolicyEndDate: moment(e.odPolicyEndDate).format(
  //           "DD/MM/YYYY"
  //         ),
  //         formateOdPolicyStartDate: moment(e.odPolicyStartDate).format(
  //           "DD/MM/YYYY"
  //         ),
  //         formateTpPolicyEndDate: moment(e.tpPolicyEndDate).format(
  //           "DD/MM/YYYY"
  //         ),
  //         formateTpPolicyStartDate:moment(e.tpPolicyStartDate).format("DD/MM/YYYY"),
  //       };
  //     })
  //     // console.log(modifiedData);
  //     setExcelData(modifiedData);
  //     setDisable(false);
  //   });
  // };

  const OpenPolicyFile = (row) => {
    if (!row?._id) {
      ToastError("Policy ID not found.");
      return;
    }

    setOpenLoader(true);
    GetPolicyFileById(row._id)
      .then((res) => {
        setOpenLoader(false);

        if (!res) {
          ToastError("Failed to fetch PDF file. No response received.");
          return;
        }
        if (res.error) {
          ToastError(res.message || "Failed to fetch PDF file.");
          return;
        }

        // The API comes back as { data: { policyFile } } or { policyFile }
        // depending on the caller — read both (same as PolicyList.js).
        const policyData = res.data || res;
        const pdfUrl = policyData?.policyFile?.downloadURL;

        if (!pdfUrl || typeof pdfUrl !== "string") {
          ToastError("No policy file available for this policy");
          return;
        }

        // downloadURL is normally base64, but can be a signed S3 URL. Calling
        // atob() on a URL is what threw "string to be decoded is not correctly
        // encoded", so branch on it instead of always decoding.
        const isUrl = /^https?:\/\//i.test(pdfUrl);
        if (isUrl) {
          const pdfWindow = window.open("", "_blank");
          pdfWindow?.document?.write(
            `<embed src="${pdfUrl}" width="100%" height="100%" />`,
          );
          return;
        }

        try {
          // Changes by Arun
          const blobData = base64toBlob(pdfUrl, "application/pdf");
          const blobUrl = URL.createObjectURL(blobData);
          const pdfWindow = window.open("", "_blank");
          pdfWindow?.document?.write(
            `<embed src="${blobUrl}" width="100%" height="100%" />`,
          );
        } catch (error) {
          console.error("Error converting base64 to blob:", error);
          ToastError("Failed to display PDF. Invalid file format.");
        }
      })
      .catch((error) => {
        setOpenLoader(false);
        console.error("Error fetching PDF:", error);
        ToastError("Failed to fetch PDF file. Please try again.");
      });
  };

  // Changes by Arun
  const base64toBlob = (base64Data, contentType) => {
    contentType = contentType || "";
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };

  React.useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false);

      return;
    }
    const requestType = button === "score" ? "SCORE" : "MASTER";
    getTableData(requestType);
  }, [queryParam.page, queryParam.limit, queryParam.search, queryParam.sort]);

  React.useEffect(() => {
    setUserType(sessionStorage.getItem("userType"));
    const isallowObj = checkUserType(sessionStorage.getItem("userType"));
    setIsAllow(isallowObj);
  }, [UserType]);

  const formatNumber = (num) => new Intl.NumberFormat("en-IN").format(num);

  const filterButton = [
    { _id: 1, label: "Master", value: "master", backgroundColor: "#008CBA" },
    { _id: 2, label: "Score", value: "score", backgroundColor: "#008CBA" },
  ];

  const [selectedFilterType, setSelectedFilterType] = useState("issueDate");

  const [showFilter, setShowFilter] = useState(false);

  const filterBoxData = [
    {
      id: 9,
      label: "Select Filter Type",
      data: [
        { label: "Issue Date", value: "issueDate", _id: "issueDate" },
        { label: "Approved Date", value: "approveDate", _id: "approveDate" },
        // Cancel Date works on the Master list only (the Score summary is not cancel-aware)
        ...(button === "score"
          ? []
          : [{ label: "Cancel Date", value: "cancelDate", _id: "cancelDate" }]),
      ],
      setState: setSelectedFilterType,
      type: "input",
      variation: "single",
      value: selectedFilterType,
      defaultValue: "issueDate",
    },
    {
      id: 1,
      label: "Select User ",
      data: userDetails,
      setState: setSelectedUser,
      value: selectedUser,
      type: "input",
      variation: "single",
    },
    {
      id: 2,
      label: "Select Branch",
      data: branchDetails,
      setState: setSelectedBranch,
      value: selectedBranch,
      type: "input",
      variation: "single",
    },
    {
      id: 3,
      label: "Select Company",
      data: companyDetails,
      setState: setSelectedCompany,
      value: selectedCompany,
      type: "input",
      variation: "multi",
    },
    {
      id: 4,
      label: "Select Booking code & Sub booking code",
      data: bookingCodeDetails,
      setState: setSelectedSubBookingCode,
      value: selectedSubBookingCode,
      type: "input",
      variation: "multi",
    },
    {
      id: 5,
      label: "Select Product & Sub Product",
      data: productDetails,
      setState: setSelectedProduct,
      value: selectedProduct,
      type: "input",
      variation: "multi",
    },
    {
      id: 6,
      label: "Select Policy",
      data: policyTypeDetails,
      setState: setSelectedPolicyType,
      value: selectedPolicyType,
      type: "input",
      variation: "multi",
    },
    {
      id: 7,
      label: "Select Date",
      setDate: handleFilterDateRangeChange,
      value: dateRange,
      type: "noDefaultDate", // Changed to noDefaultDate to prevent automatic default dates
    },
  ].filter((filter) => {
    // CLIENT users see all filters
    if (UserType === "CLIENT") {
      return true;
    }

    // Branch manager can filter by user, but only within their own branch
    // (userDetails is already limited to their branch users).
    if (filter.id === 1) {
      return (
        UserType === "CLIENT" ||
        UserType === "accountant" ||
        UserType === "branchManager"
      );
    }

    // Show Branch (2) & Booking code (4) filters ONLY for CLIENT & accountant
    if (filter.id === 2 || filter.id === 4) {
      return UserType === "CLIENT" || UserType === "accountant";
    }
    return true;
  });
  const activeFiltersCount = [
    selectedUser,
    selectedBranch,
    selectedCompany?.length ? "company" : null,
    selectedSubBookingCode?.length ? "subBooking" : null,
    selectedProduct?.length ? "product" : null,
    selectedPolicyType?.length ? "policy" : null,
    dateRange && Array.isArray(dateRange) && dateRange.length === 2
      ? "date"
      : null,
    selectedFilterType !== "issueDate" ? "filterType" : null,
  ].filter(Boolean).length;

  useEffect(() => {
    latestDateRangeRef.current = dateRange;

    if (dateRange && Array.isArray(dateRange) && dateRange.length === 2) {
      setSelectedStartDate(dayjs(dateRange[0]));
      setSelectedEndDate(dayjs(dateRange[1]));
      // Trigger search after dates are set
      // setSearchTrigger((prev) => prev + 1);
    } else {
      setSelectedStartDate(null);
      setSelectedEndDate(null);
    }
  }, [dateRange]);

  const handleClearAllState = () => {
    setSelectedUser(null);
    setDateRange(null);
    latestDateRangeRef.current = null;
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setSelectedPolicyType(null);
    setSelectedCompany(null);
    setSelectedSubBookingCode(null);
    setSelectedProduct(null);
    setSelectedBranch(null);
    setSelectedFilterType("issueDate");
  };

  const handleClearSingleFilter = (filterId) => {
    if (filterId === 1) {
      setSelectedUser(null);
    } else if (filterId === 2) {
      setSelectedBranch(null);
    } else if (filterId === 3) {
      setSelectedPolicyType(null);
    } else if (filterId === 4) {
      setSelectedCompany(null);
    } else if (filterId === 5) {
      setSelectedSubBookingCode(null);
    } else if (filterId === 6) {
      setSelectedProduct(null);
    } else if (filterId === 7) {
      setDateRange(null);
      latestDateRangeRef.current = null;
      setSelectedStartDate(null);
      setSelectedEndDate(null);
    } else if (filterId === 9) {
      setSelectedFilterType("issueDate");
    }
  };

  const [searchTrigger, setSearchTrigger] = useState(0);

  const handleSaveAllFilter = () => {
    setSearchTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    if (searchTrigger > 0) {
      const requestType = button === "score" ? "SCORE" : "MASTER";
      getTableData(requestType);
    }
  }, [searchTrigger]);

  const handleButtonClick = (value) => {
    setButton(value);
    if (value === "score" && selectedFilterType === "cancelDate") {
      setSelectedFilterType("issueDate");
    }
    const requestType = value === "score" ? "SCORE" : "MASTER";

    let effectiveRange = latestDateRangeRef.current;
    if (!effectiveRange || effectiveRange.length !== 2) {
      effectiveRange = dateRange;
    }

    let overrideStartDate = selectedStartDate;
    let overrideEndDate = selectedEndDate;

    if (effectiveRange && effectiveRange.length === 2) {
      overrideStartDate = dayjs(effectiveRange[0]);
      overrideEndDate = dayjs(effectiveRange[1]);
      setSelectedStartDate(overrideStartDate);
      setSelectedEndDate(overrideEndDate);
    }

    getTableData(requestType, {
      overrideStartDate,
      overrideEndDate,
    });
  };

  const handleMultiDelete = (items) => {
    setSelectedItems(items);
  };

  const handleColumnToggle = (id) => {
    setHeadCells((prevColumns) =>
      prevColumns.some((col) => col.id === id)
        ? prevColumns.filter((col) => col.id !== id)
        : [
            ...prevColumns,
            filteredInitialHeadCells.find((col) => col.id === id),
          ],
    );
    setSelectedColumns((prevColumns) =>
      prevColumns.some((col) => col.id === id)
        ? prevColumns.filter((col) => col.id !== id)
        : [
            ...prevColumns,
            filteredInitialHeadCells.find((col) => col.id === id),
          ],
    );
  };

  function handleFilterDateRangeChange(range) {
    setDateRange(range);
    latestDateRangeRef.current = range;
    // Don't trigger search here - let the useEffect handle it after dates are set
  }

  return (
    <>
      {/* 
      <Grid
        className="Count_Page"
        sx={{ flexDirection: { xs: "column", sm: "row" } }}
        mt={4}
        mb={4}
        gap={1}
      >
        <Grid className="Count_1" sx={{ width: "100%" }}>
          <Typography className="Total">
            {count ? formatNumber(count) : 0}
          </Typography>
          <Typography className="Title">Policy Count </Typography>
        </Grid>
        <Grid className="Count_2" sx={{ width: "100%" }}>
          <Typography className="Total">
            {summaryData?.ODTotal ? formatNumber(summaryData?.ODTotal) : 0}
          </Typography>
          <Typography className="Title">OD Total </Typography>
        </Grid>
        <Grid className="Count_3" sx={{ width: "100%" }}>
          <Typography className="Total">
            {summaryData?.TPTotal ? formatNumber(summaryData?.TPTotal) : 0}
          </Typography>
          <Typography className="Title">TP Total</Typography>
        </Grid>
        <Grid className="Count_1" sx={{ width: "100%" }}>
          <Typography className="Total">
            {summaryData?.NETTotal ? formatNumber(summaryData?.NETTotal) : 0}
          </Typography>
          <Typography className="Title">NET Total </Typography>
        </Grid>
        <Grid className="Count_2" sx={{ width: "100%" }}>
          <Typography className="Total">
            {summaryData?.total ? formatNumber(summaryData?.total) : 0}
          </Typography>
          <Typography className="Title">Total</Typography>
        </Grid>
      </Grid> */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
          {/* Summary Cards Section */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              mb: 3,
            }}
          >
            {[
              {
                label: "Policy Count",
                value: count,
                image: file,
                color: "#EFF6FF",
              },
              {
                label: "OD Total",
                value: summaryData?.ODTotal,
                image: car,
                color: "#F0FDF4",
              },
              {
                label: "TP Total",
                value: summaryData?.TPTotal,
                image: tpCar,
                color: "#FEF3C7",
              },
              {
                label: "NET Total",
                value: summaryData?.NETTotal,
                image: net,
                color: "#F3E8FF",
              },
              {
                label: "Total",
                value: summaryData?.total,
                image: total,
                color: "#FCE7F3",
              },
            ].map((item, index) => (
              <Box
                key={index}
                sx={{
                  flex: {
                    xs: "1 1 100%",
                    sm: "1 1 calc(50% - 16px)",
                    md: "1 1 calc(20% - 16px)",
                  },
                  minWidth: {
                    xs: "100%",
                    sm: "calc(50% - 16px)",
                    md: "calc(20% - 16px)",
                  },
                  backgroundColor: "#fff",
                  border: "1px solid #E4E7EC",
                  borderRadius: "8px",
                  padding: "16px",
                  boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)",
                    transform: "translateY(-2px)",
                  },
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "12px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    flex: 1,
                  }}
                >
                  <Box
                    sx={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      backgroundColor: item?.color || "#F0F9FF",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <img
                      src={item?.image}
                      alt={item?.label}
                      style={{ width: "20px", height: "20px" }}
                    />
                  </Box>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: "12px",
                      color: "#667085",
                      fontFamily: "Inter",
                    }}
                  >
                    {item?.label}
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "24px",
                    color: "#1D2939",
                    fontFamily: "Inter",
                    lineHeight: 1.2,
                    flexShrink: 0,
                  }}
                >
                  {item.value ? formatNumber(item.value) : 0}
                </Typography>
              </Box>
            ))}
          </Box>

          <Grid container className="Master_Card_Container">
            <Grid
              container
              alignItems={"center"}
              className="Master_Card_Sub_Container"
            >
              <Grid item xs={12} sm={6} md={6}>
                <Typography className="Master_Card_Tittle">
                  Master Report
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                className="d-flex"
                justifyContent={{
                  xs: "start",
                  sm: "flex-end",
                  md: "flex-end",
                }}
              >
                <Stack
                  direction={{ xs: "column", sm: "row", md: "row" }}
                  spacing={2}
                  mt={{ xs: 2, sm: 2, md: 0 }}
                >
                  <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                    <Button
                      className="Master_Card_Filter_Button w-100"
                      sx={{ width: "102px", height: "40px", gap: "8px" }}
                      startIcon={
                        <Badge
                          badgeContent={activeFiltersCount}
                          sx={{
                            "& .MuiBadge-badge": {
                              right: 5,
                              top: 3,
                              width: "14px",
                              height: "14px",
                              minWidth: "14px",
                              borderRadius: "50%",
                              fontSize: "8.91px",
                              fontWeight: "600",
                              backgroundColor: "#E50000",
                              color: "#fff",
                              padding: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            },
                          }}
                        >
                          <FilterListIcon sx={{ marginRight: "1.5px" }} />
                        </Badge>
                      }
                      onClick={() => setShowFilter(!showFilter)}
                    >
                      Filters
                    </Button>
                    <Button
                      className="Master_Card_Filter_Button w-100"
                      sx={{ width: "102px", height: "40px", gap: "8px" }}
                      onClick={() => {
                        if (!excelData.length) {
                          ToastError("No records found in Table");
                        } else {
                          if (UserType === "CLIENT") {
                            setOpenDrawer(true);
                          } else {
                            userDownloadExcel();
                          }
                        }
                      }}
                      startIcon={
                        <CloudDownloadOutlinedIcon
                          sx={{
                            color: "#344054",
                          }}
                        />
                      }
                    >
                      <p className="button-text">Export</p>
                    </Button>
                    {!isUserRole && (
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "150px", height: "40px", gap: "8px" }}
                        onClick={() => {
                          if (!selectedStartDate || !selectedEndDate) {
                            ToastError("Please select date range");
                            return;
                          }
                          setOpenPolicyFileDownload(true);
                        }}
                        startIcon={<DownloadIcon sx={{ color: "#344054" }} />}
                      >
                        <p className="button-text">Policy Files</p>
                      </Button>
                    )}
                    <CustomButton
                      fontSize="12px"
                      height="35px"
                      width="fit-content"
                      color="#fff"
                      icon={ViewColumnOutlinedIcon}
                      ref={buttonRef}
                      onClick={() => setShowColumns(true)}
                    />
                  </Stack>
                </Stack>
              </Grid>
            </Grid>

            {/* Filter Section */}
            {showFilter && (
              <Box
                sx={{
                  mb: 2,
                  overflow: "visible",
                  position: "relative",
                  zIndex: 1200,
                  minHeight: "60px",
                  width: "100%",
                  px: "18px",
                }}
              >
                <FilterBox
                  filterData={filterBoxData}
                  type={"single"}
                  handleClearAllState={handleClearAllState}
                  handleSaveAllFilter={handleSaveAllFilter}
                  handleClearSingleFilter={handleClearSingleFilter}
                  handleButtonClick={handleButtonClick}
                  selectedButton={button}
                  horizontalLayout={true}
                  hideHeader={true}
                  hideInput={true}
                  alwaysOpen={true}
                  autoApply={false}
                  hideActionButtons={true}
                  sx={{
                    "& .filter-box-container": {
                      boxShadow: "none",
                      border: "none",
                      p: 0,
                    },
                    "& .MuiPaper-root": {
                      boxShadow: "none",
                      border: "none",
                      p: 0,
                    },
                  }}
                />
                {/* Master and Score Buttons - Right Aligned */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                    mt: 2,
                  }}
                >
                  {filterButton
                    .filter((btn) => {
                      // Hide Score button if UserType is NOT "SUBCODE" or "user"
                      if (
                        btn.value === "score" &&
                        (UserType === "SUBCODE" ||
                          UserType === "user" ||
                          UserType === "operator" ||
                          UserType === "branchManager")
                      ) {
                        return false;
                      }
                      return true;
                    })
                    .map((btn, index) => (
                      <Button
                        key={index}
                        variant={
                          button === btn.value ? "contained" : "outlined"
                        }
                        sx={{
                          backgroundColor:
                            button === btn.value ? "#008CBA" : "#fff",
                          color: button === btn.value ? "#fff" : "#008CBA",
                          border: "1px solid #008CBA",
                          fontWeight: 600,
                          height: "40px",
                          "&:hover": {
                            backgroundColor:
                              button === btn.value ? "#007199" : "#f0f9fc",
                            border: "1px solid #008CBA",
                          },
                        }}
                        onClick={() => handleButtonClick(btn.value)}
                      >
                        {btn.value === "master" &&
                        (UserType === "SUBCODE" ||
                          UserType === "user" ||
                          UserType === "operator" ||
                          UserType === "branchManager")
                          ? "Search"
                          : btn.label}
                      </Button>
                    ))}
                </Box>
              </Box>
            )}

            <Grid item xs={12}>
              <Divider
                sx={{
                  backgroundColor: "#EAECF0",
                  borderWidth: 1,
                }}
              />
            </Grid>
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              className="Master_Card_Sub_Container"
              spacing={1}
              sx={{ flexWrap: "wrap", mb: 0.1 }}
            >
              <Grid item xs={12} sm={4} md={3}>
                {/* <TabFilter options={FilterOption} selectedTab={selectedTab} onTabChange={handleTabChange} /> */}
              </Grid>

              <Grid item xs={12} sm={4} md={3} sx={{ textAlign: "right" }}>
                <Input
                  className="w-100 Master_Card_Input"
                  id="search-input"
                  onChange={(e) => handleSearch(e.target.value)}
                  disableUnderline={true}
                  placeholder="Search in Access"
                  sx={{
                    width: "100%",
                    maxWidth: "300px",
                  }}
                  startAdornment={
                    <InputAdornment position="start">
                      <IconButton aria-label="search">
                        <SearchIcon sx={{ fontSize: "20px" }} />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </Grid>
            </Grid>

            <MasterCommonTable
              tableConfig={tableConfig}
              data={report}
              loading={openLoader}
              columns={headCells}
              handleOnClickBehaviour={OpenPolicyFile}
              handleMultiDelete={handleMultiDelete}
              isServerSide={true}
              tableTotalCount={count}
              tableOutputEvent={(params) => {
                setQueryParam({
                  page: params.page,
                  limit: params.limit,
                  sort: params.sort,
                  search: queryParam.search,
                });
              }}
            />
          </Grid>
        </Box>
      </Box>
      <CustomModal
        open={showColumns}
        onClose={() => setShowColumns(false)}
        title="Select Columns"
        anchorRef={buttonRef}
      >
        <CustomCheckboxList
          columns={filteredInitialHeadCells}
          selectedColumns={selectedColumns}
          handleColumnToggle={handleColumnToggle}
        />
      </CustomModal>
      <PolicyFileDownloadDialog
        open={openPolicyFileDownload}
        onClose={() => setOpenPolicyFileDownload(false)}
        apiReqBody={apiReqBody}
        requestType={button === "score" ? "SCORE" : "MASTER"}
        totalCount={count}
      />
      <Modal
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: { xs: "90%", sm: "50%", md: "30%" },
            bgcolor: "background.paper",
            height: "500px",
            borderRadius: 2,
            overflowY: "auto",
          }}
        >
          <DownloadReport
            setOpenDrawer={setOpenDrawer}
            header={headers}
            apiReqBody={apiReqBody}
          />
        </Box>
      </Modal>
    </>
  );
};
export default MasterReport;
